import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const PUT_PAYMENT_RESET = 'PUT_PAYMENT_RESET';
export const PUT_PAYMENT_LOADING = 'PUT_PAYMENT_LOADING';
export const PUT_PAYMENT_SUCCESS = 'PUT_PAYMENT_SUCCESS';
export const PUT_PAYMENT_REJECT = 'PUT_PAYMENT_REJECT';

//* ACTIONS ------------------------------------------------
export const putPaymentReset = () => ({ type: PUT_PAYMENT_RESET });
export const putPaymentLoading = () => ({ type: PUT_PAYMENT_LOADING });
export const putPaymentSuccess = (payload) => ({ type: PUT_PAYMENT_SUCCESS, payload });
export const putPaymentReject = (payload) => ({ type: PUT_PAYMENT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const putPaymentRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        data,
    }, getState);
    return request(`/api/TypePayments`, options);
};


